import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLoginByCredentials } from './useLoginByCredentials';
import { TUserAuthLoginMode } from 'js/hooks/user/store/types';
import { hideReCaptchaPopupAction, showReCaptchaPopupAction } from 'js/components/popups/ReCaptchaPopup';

export const useLoginByCredentialsWithRecaptchaPopup = () => {
    const dispatch = useDispatch();
    const loginByCredentials = useLoginByCredentials();

    return useCallback(({
        afterRegisterLogin,
        fitToPlay,
        loginMode,
        password,
        rememberMeLogin,
        userName
    }: {
        afterRegisterLogin?: boolean;
        fitToPlay?: boolean;
        loginMode?: TUserAuthLoginMode;
        password: string;
        rememberMeLogin?: boolean;
        userName: string;
    }): Promise<void> => new Promise((resolve, reject) => {
        (async () => {
            try {
                await loginByCredentials(
                    userName,
                    password,
                    rememberMeLogin,
                    afterRegisterLogin,
                    loginMode,
                    fitToPlay
                );
                resolve();
            } catch (error: any) {
                const { data: { errorCode } = {} } = error?.response || error || {};

                if (errorCode === 301) {
                    dispatch(showReCaptchaPopupAction({
                        operation: 'login',
                        onReCaptchaTokenValidate: async () => {
                            dispatch(hideReCaptchaPopupAction());

                            try {
                                await loginByCredentials(
                                    userName,
                                    password,
                                    rememberMeLogin,
                                    afterRegisterLogin,
                                    loginMode,
                                    fitToPlay
                                );
                                resolve();
                            } catch (loginError: any) {
                                reject(loginError);
                            }
                        },
                        onReCaptchaTokenError: () => {
                            dispatch(hideReCaptchaPopupAction());
                            reject(error);
                        },
                        onClose: () => {
                            reject(error);
                        }
                    }));

                    return;
                }

                reject(error);
            }
        })();
    }), [dispatch, loginByCredentials]);
};
